import {Enumify} from 'enumify';

class TabulatorOnCellClickAction extends Enumify {
  static FILTER_MAIN_TABLE = new TabulatorOnCellClickAction();
  static _ = this.closeEnum();
}

export default TabulatorOnCellClickAction;
